export const getFeedbackQuestionnaire = () => ({
	title: 'Feedback',
	pages: [
		{
			name: 'welcome',
			title: "We're sorry 😔",
			elements: [
				{
					type: 'html',
					name: 'apology',
					html: '  <body style="font-family: Arial, sans-serif; background-color: #ffffff; color: #000000;">\n<p style="text-align: justify; font-size: 16px; line-height: 1.6;">\n    We’re truly sorry that your experience with us did not meet your expectations. Your feedback is invaluable, and we appreciate your willingness to help us understand what went wrong. Our aim is to learn from your experience and make things better for you and for future clients.</br></br></p>\n\n  <p style="text-align: justify; font-size: 16px; line-height: 1.6;">\n    This short survey is designed to be respectful of your time and feelings. We’ll ask a few specific questions about different parts of your experience—first with Conveyo, then with your solicitor. We want to understand where things fell short, especially around communication, responsiveness, transparency, and how well you felt informed and supported.</br></br>\n  </p>\n\n  <p style="text-align: justify; font-size: 16px; line-height: 1.6;">\n    Thank you again for your honesty.\n  </p>\n\n</body>',
				},
			],
		},
		{
			name: 'section_1',
			title: 'Section 1: About Your Experience with Conveyo',
			elements: [
				{
					type: 'comment',
					name: 'conveyo_disappointment_notes',
					title: 'In your own words, what was the most disappointing aspect of your experience with Conveyo?',
				},
				{
					type: 'radiogroup',
					name: 'conveyo_communication_rating',
					title: 'Did you feel that Conveyo communicated clearly and kept you informed throughout the process? *',
					isRequired: true,
					choices: [
						{
							value: 'Item 1',
							text: 'Yes, completely',
						},
						{
							value: 'Item 2',
							text: 'Somewhat',
						},
						{
							value: 'Item 3',
							text: 'Rarely',
						},
						{
							value: 'Item 4',
							text: 'Never',
						},
					],
				},
				{
					type: 'comment',
					name: 'conveyo_communication_notes',
					title: 'If you wish, please share any examples or details.',
				},
				{
					type: 'radiogroup',
					name: 'conveyo_responsiveness_rating',
					title: 'How would you describe Conveyo’s responsiveness when you had questions or concerns? *',
					isRequired: true,
					choices: [
						{
							value: 'Item 1',
							text: 'Very responsive',
						},
						{
							value: 'Item 2',
							text: 'Somewhat responsive',
						},
						{
							value: 'Item 3',
							text: 'Not very responsive',
						},
						{
							value: 'Item 4',
							text: 'Not at all responsive',
						},
					],
				},
				{
					type: 'comment',
					name: 'conveyo_responsiveness_notes',
					title: 'If you wish, please give us more details.',
				},
				{
					type: 'radiogroup',
					name: 'conveyo_clarity_rating',
					title: 'Did you feel you had a clear understanding of what was happening at each stage? *',
					isRequired: true,
					choices: [
						{
							value: 'Item 1',
							text: 'Yes, completely',
						},
						{
							value: 'Item 2',
							text: 'Somewhat',
						},
						{
							value: 'Item 3',
							text: 'Not really',
						},
						{
							value: 'Item 4',
							text: 'Not at all',
						},
					],
				},
				{
					type: 'comment',
					name: 'conveyo_frustration_notes',
					title: 'Was there anything about the process with Conveyo that felt inefficient or frustrating?\r\n',
				},
			],
		},
		{
			name: 'section2',
			title: 'Section 2: About Your Experience with Your Solicitor',
			elements: [
				{
					type: 'radiogroup',
					name: 'solicitor_communication_rating',
					title: 'How did you feel about the communication from your solicitor? *',
					isRequired: true,
					choices: [
						{
							value: 'Item 1',
							text: 'Clear and helpful',
						},
						{
							value: 'Item 2',
							text: 'Sometimes unclear',
						},
						{
							value: 'Item 3',
							text: 'Often unclear',
						},
						{
							value: 'Item 4',
							text: 'Not helpful at all',
						},
					],
				},
				{
					type: 'comment',
					name: 'solicitor_communication_notes',
					title: 'If you wish, please share any examples or details.',
				},
				{
					type: 'radiogroup',
					name: 'solicitor_responsiveness_rating',
					title: 'Did your solicitor respond to you in a timely manner? *',
					isRequired: true,
					choices: [
						{
							value: 'Item 1',
							text: 'Always',
						},
						{
							value: 'Item 2',
							text: 'Sometimes',
						},
						{
							value: 'Item 3',
							text: 'Rarely',
						},
						{
							value: 'Item 4',
							text: 'Never',
						},
					],
				},
				{
					type: 'radiogroup',
					name: 'solicitor_clarity_rating',
					title: 'Did you feel your solicitor was open and transparent about your case and next steps? *',
					isRequired: true,
					choices: [
						{
							value: 'Item 1',
							text: 'Yes, always',
						},
						{
							value: 'Item 2',
							text: 'Sometimes',
						},
						{
							value: 'Item 3',
							text: 'Rarely',
						},
						{
							value: 'Item 4',
							text: 'Never',
						},
					],
				},
				{
					type: 'radiogroup',
					name: 'solicitor_supportiveness_rating',
					title: 'Did you feel supported and “in the loop” by your solicitor throughout the process? *\n',
					isRequired: true,
					choices: [
						{
							value: 'Item 1',
							text: 'Yes, always',
						},
						{
							value: 'Item 2',
							text: 'Sometimes',
						},
						{
							value: 'Item 3',
							text: 'Rarely',
						},
						{
							value: 'Item 4',
							text: 'Never',
						},
					],
				},
				{
					type: 'comment',
					name: 'solicitor_frustration_notes',
					title: 'Were there specific moments where you felt let down or frustrated by your solicitor?',
				},
			],
		},
		{
			name: 'section3',
			title: 'Section 3: Moving Forward',
			elements: [
				{
					type: 'comment',
					name: 'improvement_note',
					title: 'If you could change one thing about your experience, what would it be? *',
					isRequired: true,
				},
				{
					type: 'comment',
					name: 'suggestions_note',
					title: 'Is there anything else you’d like us to know, or suggestions for how we could do better?',
				},
				{
					type: 'html',
					name: 'closure',
					html: '</br><b>Thank you for sharing your feedback.</b>',
				},
			],
		},
	],
	showTitle: false,
	readOnly: true,
	mode: 'display',
	headerView: 'advanced',
});
